"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeDimensionTypeToJSON = exports.TimeDimensionTypeFromJSONTyped = exports.TimeDimensionTypeFromJSON = exports.TimeDimensionType = void 0;
/**
 * TimeDimensionType describes the granularity of the data reported. For example, if DAY
 * is selected, a report will be generated that contains daily aggregated metrics between
 * report_start and report_end dates that are provided in the request. Please note that report_start
 * and report_end dates are not permitted when requesting LIFETIME granularity.
 *
 * @export
 */
exports.TimeDimensionType = {
    Day: 'DAY',
    Hour: 'HOUR',
    Lifetime: 'LIFETIME'
};
function TimeDimensionTypeFromJSON(json) {
    return TimeDimensionTypeFromJSONTyped(json, false);
}
exports.TimeDimensionTypeFromJSON = TimeDimensionTypeFromJSON;
function TimeDimensionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.TimeDimensionTypeFromJSONTyped = TimeDimensionTypeFromJSONTyped;
function TimeDimensionTypeToJSON(value) {
    return value;
}
exports.TimeDimensionTypeToJSON = TimeDimensionTypeToJSON;
